import { AggregateBlueprint } from '@/components/builder/base/blueprints/AggregateBlueprint';
import { Blueprint } from '@/components/builder/base/blueprints/Blueprint';
import { HasWidth } from '@/components/builder/base/traits/HasWidth';
import { BlueprintDefinition } from '@/components/builder/details/blueprints/BlueprintDefinition';
import { VisibleBlueprint } from '@/components/builder/form/blueprints/VisibleBlueprint';
import { AlwaysChoice } from '@/components/builder/form/enums/AlwaysChoice';
import { WhenChoice } from '@/components/builder/form/enums/WhenChoice';

export const Definition: BlueprintDefinition = {
    type: 'document-details',
    name: '[[[Szczegóły dokumentu]]]',
    icon: 'fa-file',
    group: 'functionalities',
    position: 6,
};

export interface DocumentDetailsContract extends Blueprint, VisibleBlueprint, AggregateBlueprint, HasWidth {
    relatedDocumentField: string;
    moduleId: number;
}

export class DocumentDetailsType implements DocumentDetailsContract
{
    public id: string;
    public type: string;
    public name: string;
    public width: number;
    public minWidth: number;
    public visible: AlwaysChoice | WhenChoice;
    public visibleWhen: string;
    public relatedDocumentField: string;
    public moduleId: number;
    public components: Blueprint[];
    public description: Record<string, string>;
    public title: Record<string, string>;
    public showTitle: boolean;
    public color: string;

    public constructor(id: string, name: string)
    {
        this.id = id;
        this.type = Definition.type;
        this.name = name;
        this.width = 0;
        this.minWidth = 3;
        this.visible = AlwaysChoice.Always;
        this.visibleWhen = null;
        this.relatedDocumentField = null;
        this.moduleId = null;
        this.components = [];
        this.description = {};
        this.title = {};
        this.showTitle = false;
        this.color = '';
    }

    public setDefaultWidth(width: number): void
    {
        this.width = 6;
    }
}
